/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelDefs from './..\\..\\..\\com\\atproto\\label\\defs.defs.js'
import * as ActorDefs from './..\\actor\\defs.defs.js'
import * as ModerationDefs from './..\\..\\..\\com\\atproto\\moderation\\defs.defs.js'

const $nsid = 'app.bsky.labeler.defs'

type $nsid = typeof $nsid

export { $nsid }

type LabelerView = {
  $type?: 'app.bsky.labeler.defs#labelerView'
  cid: l.CidString
  uri: l.AtUriString
  labels?: LabelDefs.Label[]
  viewer?: LabelerViewerState
  creator: ActorDefs.ProfileView
  indexedAt: l.DatetimeString
  likeCount?: number
}

export type { LabelerView }

const labelerView = /*#__PURE__*/ l.typedObject<LabelerView>(
  $nsid,
  'labelerView',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
      ),
    ),
    viewer: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<LabelerViewerState>(
        (() => labelerViewerState) as any,
      ),
    ),
    creator: /*#__PURE__*/ l.ref<ActorDefs.ProfileView>(
      (() => ActorDefs.profileView) as any,
    ),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    likeCount: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0 }),
    ),
  }),
)

export { labelerView }

type LabelerPolicies = {
  $type?: 'app.bsky.labeler.defs#labelerPolicies'

  /**
   * The label values which this labeler publishes. May include global or custom labels.
   */
  labelValues: LabelDefs.LabelValue[]

  /**
   * Label values created by this labeler and scoped exclusively to it. Labels defined here will override global label definitions for this labeler.
   */
  labelValueDefinitions?: LabelDefs.LabelValueDefinition[]
}

export type { LabelerPolicies }

const labelerPolicies = /*#__PURE__*/ l.typedObject<LabelerPolicies>(
  $nsid,
  'labelerPolicies',
  /*#__PURE__*/ l.object({
    labelValues: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<LabelDefs.LabelValue>(
        (() => LabelDefs.labelValue) as any,
      ),
    ),
    labelValueDefinitions: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.LabelValueDefinition>(
          (() => LabelDefs.labelValueDefinition) as any,
        ),
      ),
    ),
  }),
)

export { labelerPolicies }

type LabelerViewerState = {
  $type?: 'app.bsky.labeler.defs#labelerViewerState'
  like?: l.AtUriString
}

export type { LabelerViewerState }

const labelerViewerState = /*#__PURE__*/ l.typedObject<LabelerViewerState>(
  $nsid,
  'labelerViewerState',
  /*#__PURE__*/ l.object({
    like: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
  }),
)

export { labelerViewerState }

type LabelerViewDetailed = {
  $type?: 'app.bsky.labeler.defs#labelerViewDetailed'
  cid: l.CidString
  uri: l.AtUriString
  labels?: LabelDefs.Label[]
  viewer?: LabelerViewerState
  creator: ActorDefs.ProfileView
  policies: LabelerPolicies
  indexedAt: l.DatetimeString
  likeCount?: number

  /**
   * The set of report reason 'codes' which are in-scope for this service to review and action. These usually align to policy categories. If not defined (distinct from empty array), all reason types are allowed.
   */
  reasonTypes?: ModerationDefs.ReasonType[]

  /**
   * The set of subject types (account, record, etc) this service accepts reports on.
   */
  subjectTypes?: ModerationDefs.SubjectType[]

  /**
   * Set of record types (collection NSIDs) which can be reported to this service. If not defined (distinct from empty array), default is any record type.
   */
  subjectCollections?: l.NsidString[]
}

export type { LabelerViewDetailed }

const labelerViewDetailed = /*#__PURE__*/ l.typedObject<LabelerViewDetailed>(
  $nsid,
  'labelerViewDetailed',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
      ),
    ),
    viewer: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<LabelerViewerState>(
        (() => labelerViewerState) as any,
      ),
    ),
    creator: /*#__PURE__*/ l.ref<ActorDefs.ProfileView>(
      (() => ActorDefs.profileView) as any,
    ),
    policies: /*#__PURE__*/ l.ref<LabelerPolicies>(
      (() => labelerPolicies) as any,
    ),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    likeCount: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0 }),
    ),
    reasonTypes: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ModerationDefs.ReasonType>(
          (() => ModerationDefs.reasonType) as any,
        ),
      ),
    ),
    subjectTypes: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ModerationDefs.SubjectType>(
          (() => ModerationDefs.subjectType) as any,
        ),
      ),
    ),
    subjectCollections: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'nsid' })),
    ),
  }),
)

export { labelerViewDetailed }
